const SourceEnum = {
  FINANCING_REQUEST: 'financing_request',
  PAYMENT_HISTORY: 'payment_history',
};

export default SourceEnum;
